import { useDataLoader } from "2g-hooks/fetch";

import { DATA } from "b2b/api/paths";

import { isEmpty } from "2g-utils-common";

export default function useSmlouvyNaroky({ ico, datumOd, datumDo }) {
  return useDataLoader({
    url: DATA.smlouvyNaroky(ico),
    method: "get",
    payload: {
      datumOd: datumOd?.getTime(),
      datumDo: datumDo?.getTime()
    },
    lazy: isEmpty(ico)
  });
}
